import { compareVersions } from "@mysnowscape/snow-lib";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

const RequireAppVersion = function ({
  children,
  version,
}: {
  children: ReactNode;
  version: string;
}) {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const activeVersion = searchParams.get("app_version") ?? "0";

  const versionOk =
    typeof version === "string" &&
    version.length > 0 &&
    compareVersions(activeVersion, version) >= 0;
  if (versionOk) {
    return children;
  }
  return (
    <>
      <p className="m-6">
        {t("requireAppVersion.outdated", { version, activeVersion })}
      </p>
      <p className="text-gray-400">
        {t("requireAppVersion.url", { url: window.location.href })}
      </p>
    </>
  );
};
export default RequireAppVersion;
